import { connect } from 'react-redux';
import CopiaECola from './copiaECola';

export default connect()(CopiaECola);
